import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorised-page',
  imports: [],
  templateUrl: './unauthorised-page.component.html',
  styleUrl: './unauthorised-page.component.scss'
})
export class UnauthorisedPageComponent {

}
